var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"swiper",staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.bannerList),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c('img',{attrs:{"src":item.path}})])}),0),_c('div',{staticClass:"swiper-pagination"})])
}
var staticRenderFns = []

export { render, staticRenderFns }